import { FieldFilterType } from "../../../../base/types"
import { IReadMultipleOptions } from "../../../../services/models"
import { ServiceRequestStatus } from "../models"
import { useAuth } from "../../../../../modules/auth"
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi"
import { useState } from "react"

export const useGetActiveServiceRequest = () => {
    const { user, siteId } = useAuth()
    const [getRecords] = useLazyReadMultipleQuery()
    const [serviceRequestId, setServiceRequestId] = useState<string>()

    const getActiveRequestId = (serviceId: string, autoApprovalServiceId?: string, approvalServiceId?: string): Promise<string> => {
        if (!user?.contactId) {
            return Promise.reject('User contact not found.')
        }

        const query: IReadMultipleOptions = {
            userId: user?.userId || '',
            portalId: siteId || '',
            tableId: "edtec365_servicerequest",
            fieldList: ["edtec365_servicerequestid"],
            filters: [{
                group: 0, filters: [
                    { field: "edtec365_requestoronbehalf", type: FieldFilterType.Const, value: user?.contactId },
                    {
                        field: "edtec365_service",
                        type: FieldFilterType.Filter,
                        value: autoApprovalServiceId ? `'${serviceId}'|'${autoApprovalServiceId}'|'${approvalServiceId}'` : serviceId
                    },
                    {
                        field: "statuscode", type: FieldFilterType.Filter,
                        value: `${ServiceRequestStatus.Draft}|${ServiceRequestStatus.Submitted}|${ServiceRequestStatus.Approved}|${ServiceRequestStatus.AutoApproved}`
                    }]
            }]
        };

        return getRecords(query)
            .unwrap()
            .then((data) => {
                if (data.records.length > 0) {
                    const requestId = data.records[0]["edtec365_servicerequestid"] as string
                    setServiceRequestId(requestId)
                    return Promise.resolve(requestId)
                }

                return Promise.reject('No active request found');
            })
            .catch(error => {
                console.error(error)
                return Promise.reject(error)
            });
    }

    return { getActiveRequestId, serviceRequestId }
}
